/* Shared funnel tab interactivity — works with any ranking-funnel snippet instance */
(function() {
  'use strict';

  /* Parse a percent value out of a string like "+12,5%" / "-3.4 %". Returns null if none. */
  function parsePct(text) {
    if (!text) return null;
    var m = String(text).match(/(-?\d+(?:[.,]\d+)?)\s*%/);
    if (!m) return null;
    return parseFloat(m[1].replace(',', '.'));
  }

  /* Score for sorting: prefer ranking-return-badge (realized growth);
     fallback to a tesis-badge containing "Obj." (target upside) for new
     positions that don't have a return badge yet. */
  function getCardScore(card) {
    var rrb = card.querySelector('.ranking-return-badge');
    if (rrb) {
      var v = parsePct(rrb.textContent);
      if (v !== null) return v;
    }
    var badges = card.querySelectorAll('.tesis-badge');
    for (var i = 0; i < badges.length; i++) {
      var t = badges[i].textContent || '';
      if (t.indexOf('Obj.') !== -1) {
        var v2 = parsePct(t);
        if (v2 !== null) return v2;
      }
    }
    return -Infinity;
  }

  /* Reorder a cards container by descending score, then re-call setTab so
     visibility reflects the new order. Returns true if it ran. */
  function sortCardsByScore(funnel, cardsWrap) {
    if (!cardsWrap) return false;
    var items = Array.prototype.slice.call(cardsWrap.children);
    if (items.length === 0) return false;
    items.sort(function(a, b) { return getCardScore(b) - getCardScore(a); });
    var frag = document.createDocumentFragment();
    items.forEach(function(it) { frag.appendChild(it); });
    cardsWrap.appendChild(frag);
    if (typeof funnel.__setTab === 'function') {
      var activeTab = funnel.querySelector('[data-funnel-tab].is-active');
      var view = activeTab ? activeTab.getAttribute('data-funnel-tab') : 'new';
      funnel.__setTab(view);
    }
    return true;
  }

  document.querySelectorAll('.rk-funnel').forEach(function(funnel) {
    var cardsWrap = document.getElementById(funnel.id + '-cards');
    var tabs = funnel.querySelectorAll('[data-funnel-tab]');
    var maxVisible = cardsWrap ? parseInt(cardsWrap.getAttribute('data-max-visible')) || 50 : 50;

    function setTab(view) {
      tabs.forEach(function(t) {
        t.classList.toggle('is-active', t.getAttribute('data-funnel-tab') === view);
      });
      if (!cardsWrap) return;

      /* Re-query cards in current DOM order so external sorts are respected. */
      var cards = cardsWrap.querySelectorAll('.rk-funnel-card-item');
      var shown = 0;
      cards.forEach(function(card) {
        var status = card.getAttribute('data-funnel-status');
        var match = (view === 'all' && status !== 'never') || status === view;
        if (match && shown < maxVisible) {
          card.style.display = '';
          shown++;
        } else {
          card.style.display = 'none';
        }
      });

      /* Render charts for visible cards */
      renderFunnelCharts(cardsWrap);
    }

    /* Expose setTab on the funnel element so external scripts can re-trigger
       the filter after reordering cards. */
    funnel.__setTab = setTab;

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        setTab(tab.getAttribute('data-funnel-tab'));
      });
    });

    /* Opt-in sort by score (data-funnel-sort="score" on the funnel root).
       Runs once after wire-up so the initial DOM order reflects the sort. */
    if (funnel.getAttribute('data-funnel-sort') === 'score') {
      /* setTimeout 0 to let any DOM mutations settle before sorting. */
      setTimeout(function() { sortCardsByScore(funnel, cardsWrap); }, 0);
    }
  });

  function renderFunnelCharts(container) {
    if (typeof Chart === 'undefined' || !window.InformeChart) {
      setTimeout(function() { renderFunnelCharts(container); }, 150);
      return;
    }
    container.querySelectorAll('[data-report-chart-js]').forEach(function(el) {
      if (el.dataset.chartRendered) return;
      var canvas = el.querySelector('.report-card-chart');
      if (!canvas || !canvas.offsetParent) return;
      el.dataset.chartRendered = 'true';
      window.InformeChart.render(canvas, {
        currency: el.dataset.currency || '',
        actual: parseFloat(el.dataset.actual) || 0,
        reportDate: el.dataset.reportDate || '',
        base: {
          m6: parseFloat(el.dataset['6m']) || 0,
          m12: parseFloat(el.dataset['12m']) || 0,
          m24: parseFloat(el.dataset['24m']) || 0
        },
        bear: {
          m6: parseFloat(el.getAttribute('data-bear-6m')) || 0,
          m12: parseFloat(el.getAttribute('data-bear-12m')) || 0,
          m24: parseFloat(el.getAttribute('data-bear-24m')) || 0
        },
        bull: {
          m6: parseFloat(el.getAttribute('data-bull-6m')) || 0,
          m12: parseFloat(el.getAttribute('data-bull-12m')) || 0,
          m24: parseFloat(el.getAttribute('data-bull-24m')) || 0
        },
        evolution: (function() { try { return JSON.parse(el.dataset.priceEvolution || '[]'); } catch(e) { return []; } })(),
        analystTargets: (function() { try { return JSON.parse(el.getAttribute('data-analyst-targets') || '[]'); } catch(e) { return []; } })(),
        validatedTesis: el.getAttribute('data-validated-tesis') || 'Base',
        showLegend: false,
        compact: true
      });
    });
  }

  /* Initial chart render for all visible funnel cards */
  function initAllCharts() {
    document.querySelectorAll('.rk-funnel-cards').forEach(function(container) {
      renderFunnelCharts(container);
    });
  }

  if (document.readyState === 'complete') {
    initAllCharts();
  } else {
    window.addEventListener('load', initAllCharts);
  }
})();
